
import React, {FC} from 'react';
import {GRAMS_PER_POUND} from 'constants/units';
import {Metric, Region, RegionColors, Result} from 'templates/reports/Section/RegionalComp/parse';
import {title} from 'utils/title';

import * as styles from './styles.module.scss';

type RowProps = {
	metric: Metric
	region: Region
	result: Result
}

const fmtMass = (metric: Metric, grams: number) => {
	if (metric === 'bone') {
		return `${grams.toFixed(0)} g`;
	}
	return `${(grams / GRAMS_PER_POUND).toFixed(1)} lb`;
};

const fmtPtile = (n: number) => {
	// return 'P' + (n < 10 ? '0' : '') + n.toFixed(0);
	return n.toFixed(0) + ' p%';
};

export const Row: FC<RowProps> = ({metric, region, result}) => {
	const val = result[region][metric];
	return (
		<div className={styles.row}>
			<div className={styles.marker} style={{
				backgroundColor: RegionColors[region],
			}} />
			<div className={styles.title}>{title(region)}</div>
			<div>{fmtMass(metric, val.grams)}</div>
			<div>{val.pct_total.toFixed(1)} %</div>
			{val.pct_ntile && (
				<div>{fmtPtile(val.pct_ntile)}</div>
			)}
		</div>
	);
};
